import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'react-bootstrap-5';
import { faCloudArrowUp } from '@fortawesome/pro-solid-svg-icons';

import ImageDropzone from '../image_dropzone';
import Button from 'shared/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/pro-solid-svg-icons';

export default function PhotoCard({
  allowUpload,
  forwardedRef,
  validFileFormats,
  onUpload
}) {
  const dropBox = (
    <Card className="photo-card-dropzone">
      <FontAwesomeIcon className="dropzone-icon" icon={faCloudArrowUp}/>
      <span><b>Drag & Drop files here</b></span>
      <span>or</span>
      <Button.Accent
        className="media-dropzone-button"
        outlined
      >
        Browse Files
      </Button.Accent>
    </Card>
  );

  return (
    <div className="photo-row" name="photo-row-container" style={{ minHeight: '250px' }}>
      <ImageDropzone
        accept={validFileFormats}
        allowUpload={allowUpload}
        className="w-100 h-100"
        disablePreview
        dropBox={dropBox}
        dropZoneClassName="w-100 h-100"
        forwardedRef={forwardedRef}
        UniqueProgressBar={ProgressBar}
        onUploadComplete={onUpload}
      />
    </div>
  );
}

function ProgressBar({ fileName, now, size }) {
  function formattedSize() {
    const MB_DIVIDER = 1_000_000;
    const KB_DIVIDER = 1_000;

    if (size >= MB_DIVIDER) {
      return `${Math.ceil(size / MB_DIVIDER)}Mb`;
    } else {
      return `${Math.ceil(size / KB_DIVIDER)}Kb`;
    }
  }

  return (
    <div className="d-flex flex-column h-100 mx-4 pb-2 pt-4">
      <div className="flex-1 d-flex flex-column justify-content-center align-items-center gap-3">
        <FontAwesomeIcon className="ds-text-primary" icon={faImage} size="2xl"/>
        <div
          className="overflow-hidden w-100 text-center"
          style={{ fontSize: '20px', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {fileName}
        </div>
      </div>
      <div className="flex-1 d-flex flex-column justify-content-center gap-2">
        <div className="d-flex justify-content-between" style={{ fontSize: '16px' }}>
          <span className="ds-text-muted">{formattedSize()}</span>
          <span>{now}%</span>
        </div>
        <div className="position-relative">
          <div className="progress-bar progress-bar-bg"></div>
          <div className="progress-bar progress-bar-progress" style={{ width: `${now}%` }}></div>
        </div>
      </div>
    </div>
  );
}

ProgressBar.propTypes = {
  fileName: PropTypes.string.isRequired,
  now: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
};

PhotoCard.propTypes = {
  allowUpload: PropTypes.func,
  forwardedRef: PropTypes.any,
  validFileFormats: PropTypes.string,
  onUpload: PropTypes.func.isRequired,
};
